import { useEffect, useState } from "react";
import "./role-access-control.css";
import secureLocalStorage from "react-secure-storage";
import { message, Select } from "antd";
import { useNavigate } from "react-router-dom";
import { fetchRoleAsDropdownThunk } from "../../../store/thunks/usersThunk";
import { useDispatch } from "react-redux";
import { fetchRolesBasedSectionsPermissionsThunk } from "../../../store/thunks/rolesThunk";

const RoleAccessControl = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const slsRole = secureLocalStorage.getItem("role");
  const slsToken = secureLocalStorage.getItem("accessToken");

  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(slsRole);
  const [rolesInfo, setRolesInfo] = useState(null);
  const [rolesData, setRolesData] = useState(null);
  const [enabledRoleParentSection, setEnabledRoleParentSection] = useState({});
  const [enabledRoleParentChildSection, setEnabledRoleParentChildSection] =
    useState({});
  const rolesInfo1 = [
    {
      parentSectionName: "QMS",
      roleBasedSectionWithPermissions: [
        {
          section_id: 1,
          sectionName: "Dashboard",
          sectionStatus: "0",
          permissions: JSON.stringify([
            { name: "View", slug: "view", status: 0 },
            { name: "Show Filters", slug: "show_filters", status: 0 },
          ]),
        },
        {
          section_id: 2,
          sectionName: "Audit Forms",
          sectionStatus: "0",
          permissions: JSON.stringify([
            { name: "Add", slug: "add", status: 0 },
            { name: "Edit", slug: "edit", status: 0 },
            { name: "View", slug: "view", status: 0 },
            { name: "Search", slug: "search", status: 0 },
          ]),
        },
        {
          section_id: 3,
          sectionName: "Audits",
          sectionStatus: "0",
          permissions: JSON.stringify([
            { name: "Perform New Audit", slug: "perform_new_audit", status: 0 },
            { name: "Download All", slug: "download_all", status: 0 },
            { name: "Download as Excel", slug: "download_as_excel", status: 0 },
            { name: "Mark as Complete", slug: "mark_as_complete", status: 0 },
            { name: "View", slug: "view", status: 0 },
            { name: "Search", slug: "search", status: 0 },
          ]),
        },
        {
          section_id: 4,
          sectionName: "Delete Audits",
          sectionStatus: "0",
          permissions: JSON.stringify([
            { name: "View", slug: "view", status: 0 },
            { name: "Download as Excel", slug: "download_as_excel", status: 0 },
            { name: "Search", slug: "search", status: 0 },
          ]),
        },
        {
          section_id: 6,
          sectionName: "Processes",
          sectionStatus: "0",
          permissions: JSON.stringify([
            { name: "Add", slug: "add", status: 0 },
            { name: "Edit", slug: "edit", status: 0 },
            { name: "View", slug: "view", status: 0 },
            { name: "Search", slug: "search", status: 0 },
          ]),
        },
        {
          section_id: 7,
          sectionName: "Clients",
          sectionStatus: "0",
          permissions: JSON.stringify([
            { name: "Add", slug: "add", status: 0 },
            { name: "Edit", slug: "edit", status: 0 },
            { name: "View", slug: "view", status: 0 },
            { name: "Search", slug: "search", status: 0 },
          ]),
        },
        {
          section_id: 7,
          sectionName: "Departments",
          sectionStatus: "0",
          permissions: JSON.stringify([
            { name: "Add", slug: "add", status: 0 },
            { name: "Edit", slug: "edit", status: 0 },
            { name: "View", slug: "view", status: 0 },
            { name: "Search", slug: "search", status: 0 },
          ]),
        },
      ],
    },
    {
      parentSectionName: "VOC",
      roleBasedSectionWithPermissions: [
        {
          section_id: 1,
          sectionName: "Add Form",
          sectionStatus: "0",
          permissions: JSON.stringify([
            { name: "Add", slug: "add", status: 0 },
            { name: "View", slug: "view", status: 0 },
          ]),
        },
        {
          section_id: 2,
          sectionName: "Forms",
          sectionStatus: "0",
          permissions: JSON.stringify([
            { name: "Send Forms", slug: "send_forms", status: 0 },
            { name: "View", slug: "view", status: 0 },
          ]),
        },
        {
          section_id: 3,
          sectionName: "Feedback Requests",
          sectionStatus: "0",
          permissions: JSON.stringify([
            { name: "View", slug: "view", status: 0 },
          ]),
        },
      ],
    },
  ];

  const roleId = 1;
  const loggedInUserRoleName = slsRole;
  const getCurrentUserRoleInfo = { role: "manager" };

  const isDisabled = loggedInUserRoleName === getCurrentUserRoleInfo.role;
  const [expandedSections, setExpandedSections] = useState({});
  const [sectionStatus, setSectionStatus] = useState({});
  const [sectionPermissionStatus, setSectionPermissionStatus] = useState({});

  const toggleSection = (sectionKey) => {
    setExpandedSections((prev) => ({
      ...prev,
      [sectionKey]: !prev[sectionKey],
    }));
  };

  /*begin::getRoles will fetch the list of Roles*/
  const getRoles = async () => {    
    await dispatch(fetchRoleAsDropdownThunk({}))
      .unwrap()
      .then((response) => {
        const temp = [];
        response?.map((role, index) => {
          temp.push({ label: role?.name, value: role?.name?.toLowerCase() });
        });
        setRoles(temp);
      })
      .catch((error) => {});
  };

  /* Fetch roles sections and permissions */
  const rolesBasedSectionsPermissions = async (action, role) => {
    const payload = { action: "fetch", role: slsRole.toUpperCase() };

    await dispatch(fetchRolesBasedSectionsPermissionsThunk(payload))
      .unwrap()
      .then((response) => {
        setRolesInfo(response?.roleInfo);        
      })
      .catch((error) => {});
  };

  /* Sync rolesData and enabledRoleParentSection when rolesInfo changes */
  useEffect(() => {
    if (rolesInfo) {
      setRolesData(rolesInfo);
      const defaultEnabledRoleParentSection = rolesInfo.reduce((acc, role) => {
        if (role.parentSectionStatus === 1) {
          acc[role.parentSectionName] = true;
        }
        return acc;
      }, {});
      setEnabledRoleParentSection(defaultEnabledRoleParentSection);

      const defaultRoleParentChildSectionEnabled = rolesInfo.reduce(
        (acc, section) => {
          section.roleBasedSectionWithPermissions.forEach((subSection) => {
            acc[subSection.sectionName] = subSection.sectionStatus;
          });
          return acc; // You must return the accumulator!
        },
        {}
      );
      setEnabledRoleParentChildSection(defaultRoleParentChildSectionEnabled);
    }
  }, [rolesInfo]);

  /* Initial fetch */
  useEffect(() => {
    getRoles();
    rolesBasedSectionsPermissions();
  }, []);
  
  return (
    <div className="container mt-5">
      <div className="card">
        <div className="card-body">
          <div className="mr-cardHeader">
            {/* Dropdown Form */}

            <form className="mb-4">
              <label>Roles:</label>
              <div>
                <Select
                  showSearch
                  allowClear
                  options={roles}
                  value={selectedRole}
                  placeholder="Select an option"
                  className="form-control w-25"
                  onChange={(val) => {
                    setSelectedRole(val);
                    rolesBasedSectionsPermissions("fetch", val);
                  }}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      ?.toLowerCase()
                      .includes(input?.toLowerCase())
                  }
                ></Select>
              </div>
            </form>
            <div className="btns">
              <span
                className="mr-buttons"
                onClick={() => {
                  navigate("/roles", {
                    state: { from: "role-access-control" },
                  });
                }}
              >
                Roles
              </span>
              <span
                className="mr-buttons"
                onClick={() => {
                  navigate("/sections", {
                    state: { from: "role-access-control" },
                  });
                }}
              >
                Sections
              </span>
              <span
                className="mr-buttons"
                onClick={() => {
                  navigate("/permissions", {
                    state: { from: "role-access-control" },
                  });
                }}
              >
                Permissions
              </span>
            </div>
          </div>
          <div className="mr-body">
            {/* parentSectionName Checkboxes */}
            <div className="mb-4">
              {rolesData &&
                rolesData.map((role, i) => (
                  <div key={i} className="form-check form-check-inline mr-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`role_${role.parentSectionName}`}
                      checked={enabledRoleParentSection[role.parentSectionName]}
                      onChange={(e) => {
                        if (selectedRole === slsRole) {
                          message.warning(
                            "You cannot change your own permission"
                          );
                        } else {
                          setEnabledRoleParentSection((prev) => ({
                            ...prev,
                            [role.parentSectionName]: e.target.checked,
                          }));
                          rolesBasedSectionsPermissions("update", {
                            type: "parent",
                            data: {
                              [role.parentSectionName]: e.target.checked,
                            },
                          });
                        }
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`role_${role.parentSectionName}`}
                    >
                      {role.parentSectionName}
                    </label>
                  </div>
                ))}
            </div>

            {/* Section & Permissions */}
            {rolesData &&
              rolesData.map((roleInfo, i) =>
                enabledRoleParentSection[roleInfo.parentSectionName] ? (
                  <div key={`role-${i}`} className="mb-3">
                    <h5 className="mb-3">{roleInfo.parentSectionName}</h5>

                    <div className="row">
                      {roleInfo.roleBasedSectionWithPermissions.map(
                        (section, j) => {
                          const sectionPermissions = JSON.parse(
                            section.permissions || "[]"
                          );
                          const sectionKey = `${
                            roleInfo.parentSectionName
                          }_${section.sectionName.replace(/ /g, "_")}`;
                          const isExpanded =
                            expandedSections[sectionKey] || false;

                          return (
                            <div className="col-md-3 mb-4" key={`${i}-${j}`}>
                              <div className="rounded border">
                                {/* Section Header */}
                                <div
                                  className="d-flex align-items-center justify-content-between p-3 bg-light mr-section-header"
                                  onClick={() => toggleSection(sectionKey)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <div className="d-flex align-items-center">
                                    <span className="font-weight-bold mr-2">
                                      {section.sectionName}{" "}
                                    </span>
                                  </div>

                                  <div
                                    className=""
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      checked={
                                        enabledRoleParentChildSection[
                                          section.sectionName
                                        ]
                                      }
                                      disabled={isDisabled}
                                      onChange={(e) => {
                                        if (selectedRole === slsRole) {
                                          message.warning(
                                            "You cannot change your own permission"
                                          );
                                        } else {
                                          e.stopPropagation();
                                          const isChecked = e.target.checked;
                                          setSectionStatus((prev) => ({
                                            ...prev,
                                            [`${roleInfo.parentSectionName}-${section.section_id}`]:
                                              isChecked,
                                          }));
                                          rolesBasedSectionsPermissions(
                                            "update",
                                            {
                                              type: "role_section",
                                              data: {
                                                [`${roleInfo.parentSectionName}-${section.section_id}`]:
                                                  isChecked,
                                              },
                                            }
                                          );
                                        }
                                      }}
                                      readOnly
                                    />
                                    <span className="mr-toggle-icon">
                                      {isExpanded ? "-" : "+"}
                                    </span>
                                  </div>
                                </div>

                                {/* Section Body */}
                                {isExpanded && (
                                  <div className="p-3">
                                    {sectionPermissions.map((perm, k) => (
                                      <div
                                        key={k}
                                        className="d-flex align-items-center justify-content-between border-bottom py-2"
                                      >
                                        <span>{perm.name}</span>
                                        <div className="onoffswitch">
                                          <input
                                            type="checkbox"
                                            className="onoffswitch-checkbox"
                                            id={`${section.parentSectionName}_${section.section_id}_onoffswitch_${perm.slug}`}
                                            checked={
                                              sectionPermissionStatus[
                                                `${section.parentSectionName}_${section.section_id}_onoffswitch_${perm.slug}`
                                              ] ?? perm.status === 1
                                            }
                                            onChange={(e) => {
                                              if (selectedRole === slsRole) {
                                                message.warning(
                                                  "You cannot change your own permission"
                                                );
                                              } else {
                                                if (
                                                  sectionStatus[
                                                    `${roleInfo.parentSectionName}-${section.section_id}`
                                                  ] === true
                                                ) {
                                                  e.stopPropagation();
                                                  const isChecked =
                                                    e.target.checked;

                                                  setSectionPermissionStatus(
                                                    (prev) => ({
                                                      ...prev,
                                                      [`${section.parentSectionName}_${section.section_id}_onoffswitch_${perm.slug}`]:
                                                        isChecked,
                                                    })
                                                  );

                                                  rolesBasedSectionsPermissions(
                                                    "update",
                                                    {
                                                      type: "role_section_permission",
                                                      data: {
                                                        [`${roleInfo.parentSectionName}-${section.section_id}`]:
                                                          isChecked,
                                                      },
                                                    }
                                                  );

                                                  if (isDisabled) {
                                                    window.toastr?.warning(
                                                      "You cannot change your permission",
                                                      "",
                                                      {
                                                        closeButton: false,
                                                        progressBar: true,
                                                        positionClass:
                                                          "toast-top-center",
                                                        timeOut: 5000,
                                                      }
                                                    );
                                                    return;
                                                  }

                                                  const updatedRoles = [
                                                    ...rolesData,
                                                  ];
                                                  updatedRoles[
                                                    i
                                                  ].roleBasedSectionWithPermissions[
                                                    j
                                                  ].permissions =
                                                    JSON.stringify(
                                                      sectionPermissions.map(
                                                        (p, index) =>
                                                          index === k
                                                            ? {
                                                                ...p,
                                                                status:
                                                                  p.status === 1
                                                                    ? 0
                                                                    : 1,
                                                              }
                                                            : p
                                                      )
                                                    );
                                                  setRolesData(updatedRoles);
                                                } else {
                                                  message.warning(
                                                    "Please check its respective Section first"
                                                  );
                                                }
                                              }
                                            }}
                                          />
                                          <label
                                            className="onoffswitch-label"
                                            htmlFor={`${section.parentSectionName}_${section.section_id}_onoffswitch_${perm.slug}`}
                                          >
                                            <span className="onoffswitch-inner"></span>
                                            <span className="onoffswitch-switch"></span>
                                          </label>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                  </div>
                ) : null
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleAccessControl;
